import React from 'react'
import CourseList from '../components/CourseList'
import NavBarLoggedIn from '../components/NavBarLoggedIn'

const Dashboard = () => {
  return (
    <div className='App'>
        <NavBarLoggedIn />
        <CourseList />
    </div>
  )
}

export default Dashboard